import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <Header />
        <main className="cart-content">
          <div className="breadcrumb">
            <Link to="/" onClick={toTop}>Home</Link>
            <span className="separator">&rsaquo;</span>
            <span className="current">Shopping Cart</span>
          </div>

          <div className="empty-cart-container">
            <div className="empty-message">Your shopping cart is empty!</div>
            <div className="continue-btn-wrapper">
              <Link to="/shop" onClick={toTop} className="btn-continue-blue">
                CONTINUE
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="cart-page">
      <Header />
      <main className="cart-content">
        <div className="breadcrumb">
          <Link to="/" onClick={toTop}>Home</Link>
          <span className="separator">&rsaquo;</span>
          <span className="current">Shopping Cart</span>
        </div>

        <div className="cart-layout">
          {/* Left Column: Cart Items & Coupon */}
          <div className="cart-main">
            <h1 className="cart-title">Cart</h1>

            <div className="cart-items-list">
              {cartItems.map((item, index) => {
                const product = getProductById(item.id);
                if (!product) return null;
                
                const itemPrice = parseFloat(product.price.replace(/,/g, ""));
                const itemTotal = (itemPrice * item.quantity).toFixed(2);
                // 获取商品的第一张图片
                const imageSrc = product.images && product.images.length > 0 ? product.images[0] : "";

                return (
                  <div key={`${item.id}-${index}`} className="cart-item">
                    <div className="item-image">
                      <img src={imageSrc} alt={product.name} />
                    </div>
                    <div className="item-details">
                      <h3 className="item-name">{product.name}</h3> 
                      <div className="item-price">Unit Price: £{product.price}</div>
                    </div>
                    <div className="item-actions">
                      <div className="quantity-control">
                        <button 
                          className="qty-btn minus" 
                          onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity - 1)}
                        >
                          <i className="fa-solid fa-minus"></i>
                        </button>
                        <span className="qty-value">{item.quantity}</span>
                        <button 
                          className="qty-btn plus"
                          onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity + 1)}
                        >
                          <i className="fa-solid fa-plus"></i>
                        </button>
                      </div>
                      <button 
                        className="remove-btn"
                        onClick={() => removeFromCart(item.id, item.size, item.color)}
                      >
                        Remove
                      </button>
                    </div>
                    <div className="item-total-price">
                      £{itemTotal}
                    </div>
                  </div>
                );
              })}
            </div>

             

            <div className="continue-shopping-wrapper">
              <Link to="/shop" onClick={toTop} className="btn-continue-shopping">
                &lt; Continue Shopping
              </Link>
            </div>
          </div>

          {/* Right Column: Order Summary */}
          <div className="cart-sidebar">
            <div className="order-summary-card">
              <div className="summary-header">
                <i className="fa-solid fa-bag-shopping summary-icon"></i>
                <h2>Order Information</h2>
              </div>
              
              <div className="summary-row">
                <span>Subtotal</span>
                <span>£{(subtotal / 1.2).toFixed(2)}</span>
              </div>
              <div className="summary-row">
                <span>VAT (20%)</span>
                <span>£{(subtotal - (subtotal / 1.2)).toFixed(2)}</span>
              </div>
              
              <div className="summary-divider"></div>
              
              <div className="summary-total-row">
                <span className="total-label">Total</span>
                <div className="total-value-wrapper">
                  <span className="total-value">£{subtotal.toFixed(2)}</span>
                  <span className="total-tax-note">INCLUDING TAXES</span>
                </div>
              </div>
              
              <button className="btn-checkout" onClick={handleCheckout}>
                Continue to checkout
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CartPage;
